"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialogActions = void 0;
var _DialogActions = require("./DialogActions");
// TODO: in v9, move styled() from DialogActions.jsx to here
var StyledDialogActions = _DialogActions.DialogActions;
exports.StyledDialogActions = StyledDialogActions;